module.exports = __webpack_public_path__ + "media/images/onesite-logo-30c8ec36.png";